<script setup>
import { onMounted } from "vue";
import useSettings from "./hooks/useSettings";

const { role, roleList, loading, getRole, getRoleList, handleSubmit } =
  useSettings();

onMounted(() => {
  getRole();
  getRoleList();
});
</script>

<template>
  <zh-table-page v-bind="{ title: '审核配置' }">
    <template #header-btn></template>
    <template #search></template>
    <template #table>
      <el-form :inline="true">
        <el-form-item label="审核角色：">
          <el-select
            v-model="role"
            filterable
            :clearable="false"
            @change="loading = false"
            style="width: 200px"
          >
            <el-option
              v-for="item in roleList"
              :key="item.id"
              :label="item.roleName"
              :value="item.roleCode"
            />
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" :disabled="loading" @click="handleSubmit()"
            >保存</el-button
          >
        </el-form-item>
      </el-form>
    </template>
  </zh-table-page>
</template>

<style scoped></style>
